import {FaAward} from 'react-icons/fa'
import { GrProjects } from "react-icons/gr";


const data = [
  { id: 1, icon: <FaAward />, title: "Experience", desc: ">3 Years Working" },
  { id: 2, icon: <GrProjects />, title: "Projects", desc: "10+Completed" },
];

export default data;